import { Collection } from 'modules/core/lib/mobx-rest'

import type Allowance from 'modules/timeoff/store/models/Allowance'
import TimeoffPolicy from 'modules/timeoff/store/models/TimeoffPolicy/Policy'

export interface AllowanceMapItem {
  oldAllowanceId: number
  newAllowanceId: number | null
}
export type BulkAssignEmployeesDto = {
  employeeIds: number[]
  mappings: AllowanceMapItem[]
  policyId: number
}

class TimeoffPolicies extends Collection<TimeoffPolicy> {
  get cacheKey(): string {
    return 'timeoffPolicies'
  }

  model() {
    return TimeoffPolicy
  }

  bulkAssignEmployees(dataStructure: BulkAssignEmployeesDto) {
    const { employeeIds, mappings, policyId } = dataStructure
    const normalizedMappings = mappings.map((obj) => {
      return {
        original_allowance_id: obj.oldAllowanceId,
        new_allowance_id: obj.newAllowanceId,
        // TODO: this is leaking backend details. The rpc should handle `newAllowanceId === null` and destroy it
        _destroy: obj.newAllowanceId === null,
      }
    })

    return this.rpc('bulk_assign_employees', {
      employee_ids: employeeIds,
      mappings: normalizedMappings,
      policy_id: policyId,
    })
  }
}

export { TimeoffPolicies }

const singleton: TimeoffPolicies = new TimeoffPolicies()

export const allowancePolicy = (allowance: Allowance) => {
  const timeoffPolicyId = allowance.attributes.timeoff_policy_id

  return singleton.get(timeoffPolicyId)
}
export default singleton
